import { Button, Form, Input, Select } from 'antd';
import { useEffect } from 'react';
import { useWarehouse } from './WarehouseStore';

function Edit() {
    const { editWarehouse, editRecord, shops } = useWarehouse();
    const [form] = Form.useForm();

    useEffect(() => {
        if (editRecord?.id) {
            form.setFieldsValue({
                name: editRecord.name,
                location: editRecord.location,
                shop_id: editRecord.shop_id,
            });
        }
    }, [editRecord]);

    return (
        <Form form={form} layout="vertical" onFinish={(values) => {
            editWarehouse({ ...values, id: editRecord.id });
        }}>
            <Form.Item label="Nomi" name="name" rules={[{ required: true, message: "Nom kiritilishi shart" }]}>
                <Input placeholder="Sklad nomini kiriting" />
            </Form.Item>
            <Form.Item label="Manzili" name="location" rules={[{ required: true, message: "Manzil kiritilishi shart" }]}>
                <Input placeholder="Manzilni kiriting" />
            </Form.Item>
            <Form.Item label="Do'kon" name="shop_id" rules={[{ required: true, message: "Do'kon tanlanishi shart" }]}>
                <Select options={shops} placeholder="Do'konni tanlang" />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary" block>Saqlash</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;